import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useFormContext } from '@grandvisionhq/forms';
import { useSelector, useDispatch } from '@grandvisionhq/state';
import { ShippingObjectTypes } from '../../../state.js';
import { saveAddressLookup } from '../../../StepShipping/actions.js';
import { getDeliveryAddress, getBillingAddress } from '../../../StepShipping/selectors.js';
import { AddressLookup } from '../components/AddressLookup.js';
import { validateInputField } from '../utils/validate-input-field.js';
import { mapDataToFormValues } from '../utils/map-data-to-form-values.js';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';

const AddressLookupContainer = ({ errorMessage: initialErrorMessage , inputFieldName ='streetName' , label , maxLength , validations , validationsWithErrorMessages  })=>{
    const [isTouched, setIsTouched] = React__default.useState(false);
    const [errorMessage1, setErrorMessage] = React__default.useState(initialErrorMessage);
    const deliveryAddress = useSelector(getDeliveryAddress);
    const billingAddress = useSelector(getBillingAddress);
    const { addressLookup  } = useCheckoutSettings();
    const { name , onChange , getInitialState  } = useFormContext();
    const currentForm = name === ShippingObjectTypes.BillingAddress ? billingAddress : deliveryAddress;
    const initialState = getInitialState && getInitialState(inputFieldName);
    const dispatch = useDispatch();
    const updateStore = React__default.useCallback((prefillData)=>{
        const dynamicForm = name === ShippingObjectTypes.BillingAddress ? {
            billingAddress: ShippingObjectTypes.BillingAddress
        } : {
            deliveryAddress: ShippingObjectTypes.DeliveryAddress
        };
        Object.entries(dynamicForm).forEach(([_, checkoutFormName])=>{
            dispatch(saveAddressLookup({
                formName: checkoutFormName,
                formData: {
                    streetName: (prefillData === null || prefillData === void 0 ? void 0 : prefillData.streetName) || '',
                    streetNumber: prefillData === null || prefillData === void 0 ? void 0 : prefillData.streetNumber,
                    city: prefillData === null || prefillData === void 0 ? void 0 : prefillData.city,
                    postalCode: prefillData === null || prefillData === void 0 ? void 0 : prefillData.postalCode,
                    region: prefillData === null || prefillData === void 0 ? void 0 : prefillData.region
                }
            }));
        });
    }, [
        dispatch,
        name
    ]);
    const updateForm = React__default.useCallback((value, initialRender)=>{
        const { isValid , errorMessage  } = validateInputField(true, value, '', validations, validationsWithErrorMessages, maxLength);
        setErrorMessage(errorMessage);
        onChange && onChange({
            name: inputFieldName,
            value,
            isTouched: initialRender ? !!(initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) : true,
            isValid
        });
    }, [
        validations,
        validationsWithErrorMessages,
        maxLength,
        onChange,
        inputFieldName,
        initialState === null || initialState === void 0 ? void 0 : initialState.isTouched, 
    ]);
    const handleOnResult = React__default.useCallback((data)=>{
        const formattedData = mapDataToFormValues(data, addressLookup);
        const prefillData = swcHelpers.objectSpread({}, currentForm, formattedData);
        updateForm(prefillData.streetName);
        updateStore(prefillData);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentForm === null || currentForm === void 0 ? void 0 : currentForm.firstName,
        currentForm === null || currentForm === void 0 ? void 0 : currentForm.lastName
    ]);
    const handleIsTouched = React__default.useCallback(()=>{
        setIsTouched(true);
    }, []);
    React__default.useEffect(()=>{
        if (!initialState) {
            return;
        }
        const { isValid , errorMessage  } = validateInputField(true, initialState.value, initialErrorMessage, validations, validationsWithErrorMessages, maxLength);
        setErrorMessage(errorMessage);
        onChange && onChange({
            name: inputFieldName,
            value: initialState.value,
            isTouched: initialState.isTouched || isTouched || Boolean(initialState.value),
            isValid
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updateForm,
        initialState === null || initialState === void 0 ? void 0 : initialState.isTouched,
        initialState === null || initialState === void 0 ? void 0 : initialState.isValid,
        initialState === null || initialState === void 0 ? void 0 : initialState.value,
        onChange,
        validations, 
    ]);
    React__default.useEffect(()=>{
        // Initializing the field in form context so it can be prefilled.
        !(currentForm === null || currentForm === void 0 ? void 0 : currentForm.streetName) && updateForm('', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ React__default.createElement(AddressLookup, {
        displayError: !Boolean(initialState === null || initialState === void 0 ? void 0 : initialState.isValid) && (Boolean(initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) || isTouched),
        displayIsValid: Boolean(initialState === null || initialState === void 0 ? void 0 : initialState.isValid) && (Boolean(initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) || isTouched),
        errorMessage: errorMessage1,
        inputFieldName: inputFieldName,
        label: label,
        setIsTouched: handleIsTouched,
        onResult: handleOnResult,
        streetName: (initialState === null || initialState === void 0 ? void 0 : initialState.value) || '',
        updateForm: updateForm
    });
};

export { AddressLookupContainer };
//# sourceMappingURL=AddressLookupContainer.js.map
